import { render, staticRenderFns } from "./common-case-pool.vue?vue&type=template&id=0dc66081&scoped=true"
import script from "./common-case-pool.vue?vue&type=script&lang=ts"
export * from "./common-case-pool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc66081",
  null
  
)

export default component.exports